import { Component, OnInit, Input, HostListener, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.css']
})
export class MultiSelectComponent implements OnChanges {

  @Input() items: any[] = [];
  @Input() title: string;
  @Input() key: string;
  @Input() placeholder: string;

  @Input() value: any[];
  @Input() unitText: string;
  @Input() selectionTextLimit = 2;

  @Output() valueChange = new EventEmitter();

  onChange;
  onTouched;
  disabled: boolean;
  checked: boolean[] = [];
  opened: boolean;
  clicked: boolean;

  writeValue(value: any[]): void {
    this.value = value || [];
    this.initValue();
  }

  ngOnChanges(data) {
    if (data.items || data.key || data.value) {
      if (!this.items) {
        this.items = [];
      }
      this.initValue();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() { }

  initValue() {
    this.checked = this.items.map(item => this.value && this.value.indexOf(this.key ? item[this.key] : item) > -1);
  }

  get dropdownTitle() {
    const checkedItems = this.items.filter((_, index) => this.checked[index]);
    return this.value && this.value.length
      ? checkedItems.length >= this.selectionTextLimit && this.unitText ? checkedItems.length + ' ' + this.unitText + 's selected' :
         checkedItems.map(item => this.title ? item[this.title] : item).join(', ')
      : this.placeholder;
  }

  open() {
    this.opened = true;
  }

  toggleOpen() {
    this.opened = !this.opened;
  }

  close() {
    this.opened = false;
  }

  change() {
    this.value = this.items.filter((_, index) => this.checked[index]).map(item => this.key ? item[this.key] : item);
    if (this.onChange) {
      this.onChange(this.value);
    }
    this.valueChange.emit(this.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-select/multi-select.component.ts